import Toastable from '@/mixins/toastable';
import AsyncComputable from '@/mixins/asyncComputable';

export default {
  mixins: [Toastable, AsyncComputable],
  props: {},
  components: {
    Loading: () => import('@/components/core/Loading.vue'),
  },
  data() {
    return {
      submitting: false,
    };
  },
  computed: {
    siteId() {
      return this.$route.params.site_id;
    },
    destination() {
      if (this.siteId) {
        return `/sites/${this.siteId}/${this.urlFragment}`;
      } else {
        return `/admin/${this.urlFragment}`;
      }
    },
  },
  methods: {
    cancel() {
      this.$router.push(this.destination);
    },
    submit(resource) {
      this.submitting = true;
      if (this.siteId) {
        resource.site = this.siteId;
      }
      return this.resourceService
        .create(resource)
        .then((result) => {
          const name = result.data.name || '';
          this.successToast(`Created ${name}!`);
          this.$router.push(this.destination);
        })
        .catch(this.failToast)
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
